module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABMklEQVQ4T6WTv07DMBDGvzNT07xE3DUJAy9AB/oOIAqMjCCQkGBhAQkJBCsTf4rgHWCAF2Ag7lrnIZqGzYcSGiukrYgUD5blu/udv7szoeGiefGJ5/dAWAGL5dxO5guMTzcevlb9ZwDfXnhsiM/mgQXTSSuOzsu2P4CJDLiOorZWNs4eUhk8M7BeB0DAi6PVRq4u2xLPXyMiq88Y7gpB2wB2psB7Y/hBCHovEjBzz42Hb78AGe4R+NoaiQbuKNpKZXCR3TlaHSWd8JGY+9YHtO/q6CYHpDIYMLBZfj4TXbmj6DBP0AkvifmgUrwnR6v+QgCA27ZWu7UAVQnE+HBi1R1L/3QJ1PpXQrmIRfBEBne1izitg21jBmHC6qKWzrSxcGw0SAWk0SgXkEafqc4ol31+AHUZnhFYv1hyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/images/icon/redx.png
// module id = VNMW
// module chunks = 110